import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { ellipsis } from 'polished'

const StyledTileTeamName = styled.div`
  ${({
    theme: {
      fonts: { goodOT: goodOTFontName },
      colors: { white },
    },
  }) => {
    return css`
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      font-weight: 500;
      font-size: 15px;
      line-height: 1;
      color: ${white};
      ${ellipsis('100%', 1)};
    `
  }}
`

const TileTeamName: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  return <StyledTileTeamName>{children}</StyledTileTeamName>
}

export default TileTeamName
